import { render, staticRenderFns } from "./SelectFloorBuilding.vue?vue&type=template&id=5839123f&"
import script from "./SelectFloorBuilding.vue?vue&type=script&lang=ts&"
export * from "./SelectFloorBuilding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports